import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatTooltipModule} from '@angular/material/tooltip';
/* Angular Material */
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {MatSelectModule} from '@angular/material/select';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTabsModule} from '@angular/material/tabs';
//nuevos agregador, portales
import {MatSidenavModule} from '@angular/material/sidenav'; // Importa MatSidenavModule
import {MatToolbarModule} from '@angular/material/toolbar';
//
import {NgxSpinnerModule} from "ngx-spinner";
import {ToastrModule} from 'ngx-toastr';
import {HttpClientModule, HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AuthGuard} from './guards/auth.guard';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {WelcomeComponent} from './welcome/welcome.component';
import {IframeLoaderComponent} from './iframe-loader/iframe-loader.component';
import {FooterComponent} from './common/footer/footer.component';
import {NavbarComponent} from './common/navbar/navbar.component';
import {LoginComponent} from './login/login.component';
import {LoginOnboardComponent} from './login-onboard/login-onboard.component';
import {AccountSettingsComponent} from './account-settings/account-settings.component';
import {MenuComponent} from './common/menu/menu.component';
import {PageHeaderComponent} from './common/page-header/page-header.component';
import {PreferencesComponent} from './account-settings/preferences/preferences.component';
import {PlansComponent} from './account-settings/plans/plans.component';
import {PlanComponent} from './partials/plan/plan.component';
import {MyPlansComponent} from './account-settings/plans/my-plans/my-plans.component';
import {PortalComponent} from './account-settings/portal/portal.component';
import {MyPortalComponent} from './partials/my-portal/my-portal.component';
import {MyPortalsComponent} from './account-settings/portal/my-portals/my-portals.component';
import {AssistantPageComponent} from './assistant/assistant-page/assistant-page.component';
import {AdminCreatePartnerComponent} from './admin-create-partner/admin-create-partner.component';
import {PortalCustomizationComponent} from './account-settings/portal-customization/portal-customization.component';
import {BasicComponent} from './plans-preview/basic/basic.component';
import {PlanBasicComponent} from './partials/plan-basic/plan-basic.component';
import {PracticalComponent} from './plans-preview/practical/practical.component';
import {PlanPracticalComponent} from './partials/plan-practical/plan-practical.component';
import {ContempoComponent} from './plans-preview/contempo/contempo.component';
import {PlanContempoComponent} from './partials/plan-contempo/plan-contempo.component';
import {FAQsComponent} from './faqs/faqs.component';
import {FAQsHoversComponent} from './faqs-hovers/faqs-hovers.component';
import {ReportsComponent} from './reports/reports.component';
import {SliderComponent} from './partials/slider/slider.component';
import {MenuPreviewComponent} from './common/menu-preview/menu-preview.component';
import {UpdatePortalComponent} from './account-settings/update-portal/update-portal.component';
import {PaymentPopupComponent} from './account-settings/plans/payment-popup/payment-popup.component';
import {FacPopupComponent} from './account-settings/plans/fac-popup/fac-popup.component';
import {PreviewPopupComponent} from './account-settings/portal-customization/preview-popup/preview-popup.component';
import {
    UpdatePortalTemplatesComponent
} from './account-settings/update-portal-templates/update-portal-template.component';
import {
    UpdatePortalFeaturesComponent
} from './account-settings/update-portal-features/update-portal-features.component';
import {UpdateSliderComponent} from './account-settings/update-portal-features/update_slider/update-slider.component';
import {UpdatePlanComponent} from './account-settings/update-portal-plan/update-plan/update-plan.component';
import {CreatePlanComponent} from './account-settings/update-portal-plan/create-plan/create-plan.component';
import {CreateAccountComponent} from './create-account/create-account.component';
import {UnauthorizedComponent} from './unauthorized/unauthorized.component';
import {AccessDeniedComponent} from './access-denied/access-denied.component';
import {NotFoundComponent} from './not found/not-found.component';
import {UnauthorizedStepComponent} from './unauthorized-step/unauthorized-step.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {CongratulationComponent} from './congratulation/congratulation.component';
import {ChangeTemplateComponent} from './change-template/change-template.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatTableModule} from '@angular/material/table';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatPaginatorModule} from '@angular/material/paginator';
import {CustomerPlansComponent} from './customer-plans/customer-plans.component';
import {CustomerCardsComponent} from './customer-cards/customer-cards.component';
import {UpdateCardComponent} from './customer-cards/update-card/update-card.component';
import {BillingAddressPickerComponent} from './shared/billing-address-picker/billing-address-picker.component';
import {CustomerInvoicesComponent} from './customer-invoices/customer-invoices.component';
import {RefundInvoiceDialogComponent} from './customer-invoices/refund-invoice-dialog/refund-invoice-dialog.component';
import {CustomerUpdateComponent} from './customer-update/customer-update.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {CreateCardPopupComponent} from './customer-cards/create-card-popup/create-card-popup.component';
import {CustomerPlanUpdateComponent} from './customer-plans/customer-plan-update/customer-plan-update.component';
import {CustomerInvoiceDetailComponent} from './customer-invoice-detail/customer-invoice-detail.component';
import {RefundReceiptDialogComponent} from './customer-invoice-detail/refund-receipt-dialog/refund-receipt-dialog.component';
import {CheckoutComponent} from './partials/checkout/checkout.component';
import {NavbarcheckoutComponent} from './partials/navbar/navbar.component';
import {HeaderComponent} from './partials/header/header.component';
import {SidebarComponent} from './partials/sidebar/sidebar.component';
import {DashboardComponent} from './partials/dashboard/dashboard.component';
import {ContentDashboardComponent} from './partials/content-dashboard/content-dashboard.component';
import {CreditCardComponent} from './partials/credit-card/credit-card.component';
import {SuscriptionComponent} from './partials/mis-suscripciones/suscription/suscription.component';
import {DireccionesComponent} from './partials/direcciones/direcciones.component';
import {AddressComponent} from './partials/direcciones/address/address.component';
import {CreditcardInfoComponent} from './partials/credit-card/creditcard-info/creditcard-info.component';
import {ChangePassComponent} from './partials/change-pass/change-pass.component';
import {LoginpreviewComponent} from './partials/login/login.component';
import {AddClientComponent} from './add-client/add-client.component';
import {ConfirmDialogComponent} from './partials/my-portal/confirm-dialog/confirm-dialog.component';
import {CustomerAddressUpdateComponent} from './customer-address-update/customer-address-update.component';
import {ConfigurationsComponent} from './account-settings/configurations/configurations.component';
// import { FlexLayoutModule } from '@angular/flex-layout';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatRadioModule} from '@angular/material/radio';
import {ProcessingComponent} from './processing/processing.component';
import {
    AppDialogContainerComponent
} from './account-settings/plans/app-dialog-container/app-dialog-container.component';
import {Logging} from "./interceptors/logging.interceptor";
import {HistoricReportComponent} from "./historic-report/historic-report.component";
import {ListFailedPaymentComponent} from './list-failed-payment/list-failed-payment.component';
import {SelectPortalComponent} from './select-portal/select-portal.component';
import {AdminSessionSwitcherComponent} from './admin-session-switcher/admin-session-switcher.component';
import {OnboardingUsersComponent} from './onboarding-users/onboarding-users.component';
import {
    OnboardingUserCreateComponent
} from './onboarding-users/onboarding-user-create/onboarding-user-create.component';
import {
    OnboardingUserUpdateComponent
} from './onboarding-users/onboarding-user-update/onboarding-user-update.component';
import {OnboardingUsersRolesComponent} from './onboarding-users-roles/onboarding-users-roles.component';
import {AllowedOriginsComponent} from './allowed-origins/allowed-origins.component';
import {
    OnboardingUserRoleCreateComponent
} from './onboarding-users-roles/onboarding-user-role-create/onboarding-user-role-create.component';
import {
    OnboardingUserRoleUpdateComponent
} from './onboarding-users-roles/onboarding-user-role-update/onboarding-user-role-update.component';
import {ValidatePinComponent} from './validate-pin/validate-pin.component';
import {AppliedChargesComponent} from './applied-charges/applied-charges.component';
import {ServiceLaunchReportComponent} from './service-launch-report/service-launch-report.component';
import {RefundReportComponent} from './refund-report/refund-report.component';
import {AuthInterceptor} from "./interceptors/auth.interceptor";
import { SocialLoginModule, SocialAuthServiceConfig, GoogleLoginProvider } from '@abacritt/angularx-social-login';
import { environment } from '../environments/environment';
import { PinValidationModalComponent } from './pin-validation-modal/pin-validation-modal.component';
import { PasskeyOnboardingModalComponent } from './components/passkey-onboarding-modal/passkey-onboarding-modal.component';
import { CatalogTranslatePipe } from './pipes/catalog-translate.pipe';
import { DynamicTranslatePipe } from './pipes/dynamic-translate.pipe';
import { RagAuthInterceptor } from './chatbot/interceptors/rag-auth.interceptor';
import { ChatWidgetComponent } from './chatbot/components/chat-widget/chat-widget.component';

// Factory function for ngx-translate (loader simple sin interceptor)
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AppComponent,
        WelcomeComponent,
        IframeLoaderComponent,
        NavbarComponent,
        LoginComponent,
        CreateAccountComponent,
        LoginOnboardComponent,
        AccountSettingsComponent,
        PreferencesComponent,
        PlansComponent,
        PlanComponent,
        MyPlansComponent,
        PortalComponent,
        PortalCustomizationComponent,
        BasicComponent,
        PlanBasicComponent,
        PracticalComponent,
        PlanPracticalComponent,
        ContempoComponent,
        PlanContempoComponent,
        FAQsComponent,
        FAQsHoversComponent,
        ReportsComponent,
        SliderComponent,
        MenuPreviewComponent,
        UpdatePortalComponent,
        UpdatePortalTemplatesComponent,
        UpdatePortalFeaturesComponent,
        PaymentPopupComponent,
        FacPopupComponent,
        PreviewPopupComponent,
        UpdateSliderComponent,
        UpdatePlanComponent,
        CreatePlanComponent,
        UnauthorizedComponent,
        AccessDeniedComponent,
        UnauthorizedStepComponent,
        NotFoundComponent,
        ResetPasswordComponent,
        CongratulationComponent,
        ChangeTemplateComponent,
        CustomerPlansComponent,
        CustomerCardsComponent,
        UpdateCardComponent,
        CustomerInvoicesComponent,
        RefundInvoiceDialogComponent,
        CustomerUpdateComponent,
        CustomerPlanUpdateComponent,
        CreateCardPopupComponent,
        CustomerInvoiceDetailComponent,
        RefundReceiptDialogComponent,
        CheckoutComponent,
        NavbarcheckoutComponent,
        HeaderComponent,
        SidebarComponent,
        DashboardComponent,
        ContentDashboardComponent,
        CreditCardComponent,
        SuscriptionComponent,
        DireccionesComponent,
        AddressComponent,
        CreditcardInfoComponent,
        ChangePassComponent,
        LoginpreviewComponent,
        AddClientComponent,
        ConfirmDialogComponent,
        CustomerAddressUpdateComponent,
        ConfigurationsComponent,
        ProcessingComponent,
        AppDialogContainerComponent,
        HistoricReportComponent,
        ListFailedPaymentComponent,
        SelectPortalComponent,
        OnboardingUsersComponent,
        OnboardingUserCreateComponent,
        OnboardingUserUpdateComponent,
        OnboardingUsersRolesComponent,
        OnboardingUserRoleCreateComponent,
        OnboardingUserRoleUpdateComponent,
                ValidatePinComponent,
        AppliedChargesComponent,
        ServiceLaunchReportComponent,
        RefundReportComponent,
        AllowedOriginsComponent
    ],
    imports: [
        CatalogTranslatePipe,
        DynamicTranslatePipe,
        MyPortalsComponent,
        AssistantPageComponent,
        AdminCreatePartnerComponent,
        PinValidationModalComponent,
        PasskeyOnboardingModalComponent,
        ChatWidgetComponent,
        MenuComponent,
        PageHeaderComponent,
        BillingAddressPickerComponent,
        FooterComponent,
        AdminSessionSwitcherComponent,
        MatDatepickerModule,
        MatNativeDateModule,
        FormsModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatTooltipModule,
        BrowserModule,
        MatSlideToggleModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatExpansionModule,
        MatMenuModule,
        MatInputModule,
        MatDialogModule,
        MatRadioModule,
        MatTableModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatPaginatorModule,
        MatCheckboxModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatSidenavModule,
        MatButtonModule,
        RouterModule,
        FormsModule,
        MatToolbarModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgxSpinnerModule,
        SocialLoginModule,
        ToastrModule.forRoot({
            timeOut: 5000,
            positionClass: 'toast-top-center',
            preventDuplicates: true
        }), // ToastrModule added
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RagAuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: Logging,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [
                    {
                        id: GoogleLoginProvider.PROVIDER_ID,
                        provider: new GoogleLoginProvider(environment.googleClientId)
                    }
                ],
                onError: (err) => {
                    console.error('Error en Social Auth:', err);
                }
            } as SocialAuthServiceConfig,
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
